import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { updateBudgetingMethod } from '../service/budgetingMethodService'
import { budgetingMethodQueryKeys } from '../queries/budgetingMethodQueryKeys'
import { BudgetingMethodData } from '../types'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'

export const useUpdateBudgetingMethod = () => {
  const queryClient = useQueryClient()
  const companyId = useSelector(contextCompanyIdSelector)
  const { budgetingScenario } = useSelector(filtersSelector)

  return useMutation({
    mutationKey: ['budget', 'budgetingMethod'],
    mutationFn: async (data: BudgetingMethodData) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }
      return updateBudgetingMethod(data, companyId, budgetingScenario?.id)
    },

    onSuccess: () => {
      // Invalidate budgeting method queries
      queryClient.invalidateQueries({
        queryKey: budgetingMethodQueryKeys.all
      })

      // Note: Financial statements invalidation is handled by global mutation observer
      // in src/services/api/queryClient.ts
    },

    onError: error => {
      console.error('Error updating budgeting method:', error)
    }
  })
}
